export default __webpack_public_path__ + "static/media/cancel_u1it.0f23f14b.svg";